export default {
    name: "deep_learning",
    type: "wmsTiled",
    switcher:{},
    tiled: true,
    layers: [],
    serverType: "geoserver",
    styles: "",
    version:"1.1.0",
    format: "image/png",
    url: "/geoserver/wms",
    visible: false,
    opacity: 1,
    epsg: 5514,
}
